import { collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/Iterables.mjs';
import { mapCapacity1h45rc3eh9p2l as mapCapacity } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/collectionJs.mjs';
import { coerceAtLeast2bkz8m9ik7hep as coerceAtLeast } from '../../../../kotlin-kotlin-stdlib/kotlin/ranges/_Ranges.mjs';
import { LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/LinkedHashMap.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { Comparable198qfk8pnblz0 as Comparable } from '../../../../kotlin-kotlin-stdlib/kotlin/Comparable.mjs';
import { listOf1jh22dvmctj1r as listOf } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/CollectionsKt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        this.Continue_1 = new (HttpStatusCode())(100, 'Continue');
        this.SwitchingProtocols_1 = new (HttpStatusCode())(101, 'Switching Protocols');
        this.Processing_1 = new (HttpStatusCode())(102, 'Processing');
        this.OK_1 = new (HttpStatusCode())(200, 'OK');
        this.Created_1 = new (HttpStatusCode())(201, 'Created');
        this.Accepted_1 = new (HttpStatusCode())(202, 'Accepted');
        this.NonAuthoritativeInformation_1 = new (HttpStatusCode())(203, 'Non-Authoritative Information');
        this.NoContent_1 = new (HttpStatusCode())(204, 'No Content');
        this.ResetContent_1 = new (HttpStatusCode())(205, 'Reset Content');
        this.PartialContent_1 = new (HttpStatusCode())(206, 'Partial Content');
        this.MultiStatus_1 = new (HttpStatusCode())(207, 'Multi-Status');
        this.MultipleChoices_1 = new (HttpStatusCode())(300, 'Multiple Choices');
        this.MovedPermanently_1 = new (HttpStatusCode())(301, 'Moved Permanently');
        this.Found_1 = new (HttpStatusCode())(302, 'Found');
        this.SeeOther_1 = new (HttpStatusCode())(303, 'See Other');
        this.NotModified_1 = new (HttpStatusCode())(304, 'Not Modified');
        this.UseProxy_1 = new (HttpStatusCode())(305, 'Use Proxy');
        this.SwitchProxy_1 = new (HttpStatusCode())(306, 'Switch Proxy');
        this.TemporaryRedirect_1 = new (HttpStatusCode())(307, 'Temporary Redirect');
        this.PermanentRedirect_1 = new (HttpStatusCode())(308, 'Permanent Redirect');
        this.BadRequest_1 = new (HttpStatusCode())(400, 'Bad Request');
        this.Unauthorized_1 = new (HttpStatusCode())(401, 'Unauthorized');
        this.PaymentRequired_1 = new (HttpStatusCode())(402, 'Payment Required');
        this.Forbidden_1 = new (HttpStatusCode())(403, 'Forbidden');
        this.NotFound_1 = new (HttpStatusCode())(404, 'Not Found');
        this.MethodNotAllowed_1 = new (HttpStatusCode())(405, 'Method Not Allowed');
        this.NotAcceptable_1 = new (HttpStatusCode())(406, 'Not Acceptable');
        this.ProxyAuthenticationRequired_1 = new (HttpStatusCode())(407, 'Proxy Authentication Required');
        this.RequestTimeout_1 = new (HttpStatusCode())(408, 'Request Timeout');
        this.Conflict_1 = new (HttpStatusCode())(409, 'Conflict');
        this.Gone_1 = new (HttpStatusCode())(410, 'Gone');
        this.LengthRequired_1 = new (HttpStatusCode())(411, 'Length Required');
        this.PreconditionFailed_1 = new (HttpStatusCode())(412, 'Precondition Failed');
        this.PayloadTooLarge_1 = new (HttpStatusCode())(413, 'Payload Too Large');
        this.RequestURITooLong_1 = new (HttpStatusCode())(414, 'Request-URI Too Long');
        this.UnsupportedMediaType_1 = new (HttpStatusCode())(415, 'Unsupported Media Type');
        this.RequestedRangeNotSatisfiable_1 = new (HttpStatusCode())(416, 'Requested Range Not Satisfiable');
        this.ExpectationFailed_1 = new (HttpStatusCode())(417, 'Expectation Failed');
        this.UnprocessableEntity_1 = new (HttpStatusCode())(422, 'Unprocessable Entity');
        this.Locked_1 = new (HttpStatusCode())(423, 'Locked');
        this.FailedDependency_1 = new (HttpStatusCode())(424, 'Failed Dependency');
        this.TooEarly_1 = new (HttpStatusCode())(425, 'Too Early');
        this.UpgradeRequired_1 = new (HttpStatusCode())(426, 'Upgrade Required');
        this.TooManyRequests_1 = new (HttpStatusCode())(429, 'Too Many Requests');
        this.RequestHeaderFieldTooLarge_1 = new (HttpStatusCode())(431, 'Request Header Fields Too Large');
        this.InternalServerError_1 = new (HttpStatusCode())(500, 'Internal Server Error');
        this.NotImplemented_1 = new (HttpStatusCode())(501, 'Not Implemented');
        this.BadGateway_1 = new (HttpStatusCode())(502, 'Bad Gateway');
        this.ServiceUnavailable_1 = new (HttpStatusCode())(503, 'Service Unavailable');
        this.GatewayTimeout_1 = new (HttpStatusCode())(504, 'Gateway Timeout');
        this.VersionNotSupported_1 = new (HttpStatusCode())(505, 'HTTP Version Not Supported');
        this.VariantAlsoNegotiates_1 = new (HttpStatusCode())(506, 'Variant Also Negotiates');
        this.InsufficientStorage_1 = new (HttpStatusCode())(507, 'Insufficient Storage');
        this.allStatusCodes_1 = allStatusCodes();
        var tmp = this;
        // Inline function 'kotlin.collections.associateBy' call
        var this_0 = this.allStatusCodes_1;
        var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
        // Inline function 'kotlin.collections.associateByTo' call
        var destination = LinkedHashMap().new_kotlin_collections_LinkedHashMap_31p40q_k$(capacity);
        var _iterator__ex2g4s = this_0.iterator_jk1svi_k$();
        while (_iterator__ex2g4s.hasNext_bitz1p_k$()) {
          var element = _iterator__ex2g4s.next_20eer_k$();
          var tmp$ret$2 = element.value_1;
          destination.put_4fpzoq_k$(tmp$ret$2, element);
        }
        tmp.statusCodesMap_1 = destination;
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var HttpStatusCodeClass;
function HttpStatusCode() {
  if (HttpStatusCodeClass === VOID) {
    class $ {
      constructor(value, description) {
        Companion_getInstance();
        this.value_1 = value;
        this.description_1 = description;
      }
      toString() {
        return '' + this.value_1 + ' ' + this.description_1;
      }
      equals(other) {
        var tmp;
        if (other instanceof HttpStatusCode()) {
          tmp = other.value_1 === this.value_1;
        } else {
          tmp = false;
        }
        return tmp;
      }
      hashCode() {
        return this.value_1;
      }
      compareTo_ro40fh_k$(other) {
        return this.value_1 - other.value_1 | 0;
      }
      compareTo_hpufkf_k$(other) {
        return this.compareTo_ro40fh_k$(other instanceof HttpStatusCode() ? other : THROW_CCE());
      }
    }
    initMetadataForClass($, 'HttpStatusCode', VOID, VOID, [Comparable()]);
    HttpStatusCodeClass = $;
  }
  return HttpStatusCodeClass;
}
function allStatusCodes() {
  return listOf([Companion_getInstance().Continue_1, Companion_getInstance().SwitchingProtocols_1, Companion_getInstance().Processing_1, Companion_getInstance().OK_1, Companion_getInstance().Created_1, Companion_getInstance().Accepted_1, Companion_getInstance().NonAuthoritativeInformation_1, Companion_getInstance().NoContent_1, Companion_getInstance().ResetContent_1, Companion_getInstance().PartialContent_1, Companion_getInstance().MultiStatus_1, Companion_getInstance().MultipleChoices_1, Companion_getInstance().MovedPermanently_1, Companion_getInstance().Found_1, Companion_getInstance().SeeOther_1, Companion_getInstance().NotModified_1, Companion_getInstance().UseProxy_1, Companion_getInstance().SwitchProxy_1, Companion_getInstance().TemporaryRedirect_1, Companion_getInstance().PermanentRedirect_1, Companion_getInstance().BadRequest_1, Companion_getInstance().Unauthorized_1, Companion_getInstance().PaymentRequired_1, Companion_getInstance().Forbidden_1, Companion_getInstance().NotFound_1, Companion_getInstance().MethodNotAllowed_1, Companion_getInstance().NotAcceptable_1, Companion_getInstance().ProxyAuthenticationRequired_1, Companion_getInstance().RequestTimeout_1, Companion_getInstance().Conflict_1, Companion_getInstance().Gone_1, Companion_getInstance().LengthRequired_1, Companion_getInstance().PreconditionFailed_1, Companion_getInstance().PayloadTooLarge_1, Companion_getInstance().RequestURITooLong_1, Companion_getInstance().UnsupportedMediaType_1, Companion_getInstance().RequestedRangeNotSatisfiable_1, Companion_getInstance().ExpectationFailed_1, Companion_getInstance().UnprocessableEntity_1, Companion_getInstance().Locked_1, Companion_getInstance().FailedDependency_1, Companion_getInstance().TooEarly_1, Companion_getInstance().UpgradeRequired_1, Companion_getInstance().TooManyRequests_1, Companion_getInstance().RequestHeaderFieldTooLarge_1, Companion_getInstance().InternalServerError_1, Companion_getInstance().NotImplemented_1, Companion_getInstance().BadGateway_1, Companion_getInstance().ServiceUnavailable_1, Companion_getInstance().GatewayTimeout_1, Companion_getInstance().VersionNotSupported_1, Companion_getInstance().VariantAlsoNegotiates_1, Companion_getInstance().InsufficientStorage_1]);
}
//region block: exports
export {
  Companion_getInstance as Companion_getInstanceu2wrlss616lb,
  HttpStatusCode as HttpStatusCode3o1wkms10pg4k,
};
//endregion

//# sourceMappingURL=HttpStatusCode.mjs.map
